import axios from "axios";

import {
    IExternalOrderLinkClient,
    ExternalOrderLinkClient,
    SalesClient,
    ISalesClient
} from "../api/clients.api";
import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";

const hostName = window.location.hostname;
export const apiBaseUrl = hostName == 'localhost' ? 'http://localhost:8080' : 'https://' + hostName;

export class ApiClients {
    externalClient: IExternalOrderLinkClient = null;
    salesClient: ISalesClient = null;

    constructor(configuration: ApiClientConfig) {
        let axiosInstance = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500
            }
        });

        axiosInstance.defaults.withCredentials = true;

        this.externalClient = new ExternalOrderLinkClient(configuration, apiBaseUrl, axiosInstance);
        this.salesClient = new SalesClient(configuration, apiBaseUrl, axiosInstance);

        axiosInstance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            if(error.response?.status == 401) {
                window.location.href = "/login";
            }
        });
    }
}


